import * as moment from 'moment';

export default (year: number) =>
  moment()
    .year(year)
    .toISOString();
